import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconGuarantee from 'components/icons/iconGuarantee';
const WarrantyIcon = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <IconGuarantee width="20" height="26" color={color} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
WarrantyIcon.propTypes = {
  color: PropTypes.string
};
export default WarrantyIcon;